import type { ApiConversationUser } from '@/api/conversations/types/index.ts';
import Model from '@/entities/Model.js';

export default class ConversationUser extends Model {
    declare id: number;

    declare userId: number;

    declare lastMessageReadId: number | null;

    declare allMessagesReadAt: string | null;

    static get defaults() {
        return {
            id: 0,
            userId: 0,
            lastMessageReadId: null,
            allMessagesReadAt: null,
        };
    }

    static fromApi(conversationUser: ApiConversationUser): ConversationUser {
        return new ConversationUser({
            id: conversationUser.id,
            userId: conversationUser.userId,
            lastMessageReadId: conversationUser.lastMessageReadId,
            allMessagesReadAt: conversationUser.allMessagesReadAt,
        });
    }

    constructor(initialValues: Partial<ConversationUser> = {}) {
        super(initialValues);
    }
}
